import { Global } from '@/Service/GlobalService'
import { swal } from '@/Service/SweetAlert2'

import { UserLogin, isUserLogin, isGuestLogin } from '@/Service/APIService'

export const Auth = {
  methods: {
    Login: async function(phone, password) {
      const params = {
        phone: phone,
        password: password
      }

      const response = await UserLogin(params)

      switch (response.data.Message) {
        case Global.API.LOGIN.LOGIN_SUCCESS:
          localStorage.setItem('UserJWT', response.data.token)
          swal.alertSuccess(Global.MESSAGE.LOGIN.LOGIN_SUCCESS, () => this.$router.push({ name: 'Home' }))
          this.isLogin()
          break
        default:
          swal.alertErrorText(Global.MESSAGE.LOGIN.LOGIN_FAILED, "帳號或密碼錯誤")
      }
    },
    /**
     * 還原登入狀態：
     * 1. 優先判斷會員（isUserLogin）
     * 2. 若非會員但有 JWT，則再判斷是否為遊客（isGuestLogin，使用 api_guest guard）
     * 3. 全部都未登入時，清空 Global.User / Global.isGuest
     */
    isLogin: async function() {
      // 1. 嘗試還原會員登入狀態
      try {
        const response = await isUserLogin()
        if (response.data?.Message === 'IS_LOGIN') {
          Global.User = response.data.User
          Global.isGuest = false
          Global.emit(Global.EVENT.CHECK_USER_LOGIN, Global.User)
          return
        }
      } catch (e) {
        // 會員驗證失敗（例如 guest token），繼續嘗試遊客
      }

      // 2. 嘗試還原遊客登入狀態（使用 api_guest guard）
      try {
        const guestRes = await isGuestLogin()
        if (guestRes.data?.Message === 'IS_GUEST') {
          const guestId = guestRes.data.guestId
          const name = guestRes.data.Name || ('遊客' + guestId)
          Global.User = { id: guestId, Name: name }
          Global.isGuest = true
          Global.emit(Global.EVENT.CHECK_USER_LOGIN, Global.User)
          return
        }
      } catch (e) {
        // 遊客驗證失敗，視為未登入
      }

      // 3. 皆未登入：清空狀態，必要時保留原本的導向行為
      Global.User = null
      Global.isGuest = null

      const routeName = this.$route.name
      const routePath = this.$route.path
      const pathAllowed = routePath === '/' || routePath.startsWith('/Orders') || routePath.startsWith('/Shop')
      if (!['Home', 'Orders', 'Shop'].includes(routeName) && !pathAllowed) {
        this.$router.push({ name: 'Home' })
      }
    }
  }
}